export const zh_hk = {
    index: {
        header_1: '請問有什麼可以幫忙 ',
        header_2: '儲存類型',
        header_3: ' 請問閣下需要什麼',
        select_option: '請選擇一個項目以繼續',
        skip_button_text: '跳過 - 顯示所有價格',
        personal: '個人',
        personalText: '儲存個人物品、紀念品和小型傢俱',
        business: '企業/公司',
        businessText: '儲存商業庫存、文件和設備'
    },
    journey_bar: {
        step_1: '儲存類型',
        step_2: '儲存呎吋',
        step_3_a: '價格',
        step_3_b: '預訂',
        step_4: '確認',
        step_5: '付款',
        step_6: '摘要',
    },
    unit_listing: {
        header_1: '價錢多少 ',
        header_2: '空間',
        header_3: ' 請問閣下需要什麼',
        no_units: '沒有可租用的倉',
    },
    book_unit: {
        header_1: '請選擇 ',
        header_2: '交易',
        header_3: ' 以下',
        deals: ' 交易',
        inclusions: '包括什麼',
    },
    customise_booking: {
        header_mobile: '選擇項目',
        upgrade: '升級',
    },
    descriptor: {
        idealFor: '理想適用於',
    },
    carousel: {
        smaller: '較小的',
        larger: '較大的',
    },
    stack: {
        inclusions: '包括什麼',
    },
    labels: {
        small: '小',
        medium: '中',
        large: '大',
        or: '或',
    },
    time: {
        per_week: '每週',
        per_month: '每月',
    },
    sizeSlider: {
        small: '小',
        medium: '中',
        large: '大',
    },
    cta: {
        select: '選擇',
        continue: '繼續',
        enquire_now: '現在查詢',
        call_us_now: '現在致電我們',
        cancel: '取消',
        close: '關閉',
        bigger_unit: '需要更大的單位嗎？',
        email_us: '發送電子郵件給我們',
        call_us: '致電我們',
        step_3: {
            continue: '繼續',
        }
    },
    unit_card: {
        no_price_chane: '價格不變',
        valued_at: '價值',
        customise_booking: '自訂預訂',
        alternative_unit_options: '替代單位選項',
        extra: '額外的',
        save: '節省',
    },
    coupon_code: {
        title: '促銷代碼 / 優惠券',
        apply: '申請',
        placeholder: '在此輸入您的優惠碼或折扣碼',
        alerts: {
            success: '促銷代碼應用成功',
            error: '促銷代碼已過期或無效',
        },
    },
    contact_card: {
        error: '錯誤',
        error_text: '提交表格時發生錯誤。如果問題持續存在，請再試一次或聯繫我們的網站',
        phone: '聯絡電話',
        email: '電子郵件',
        first_name: '名字',
        last_name: '姓氏',
        email_address: '電子郵件地址',
        move_in_date: '入倉日期',
        phone_number: '聯絡電話',
        address: '地址',
        postcode: '郵政編碼',
        city: '城市',
        state: '洲/省',
        reservation: {
            title: '預訂',
            subtitle: '快完成了！我們只需要再一些資料來完成您的預訂。',
            success: '已預訂！',
            success_detail: '謝謝，您已預訂已成功。',
        },
        quote: {
            title: '報價詳情',
            subtitle: '快完成了！我們只需要再一些資料，報價將通過電子郵件發送給您。',
            success: '報價已發送！',
            success_detail: '謝謝，您的報價已發送到您的收件箱。',
        },
        showPrices: {
            title: '显示价格',
            form_title: '显示价格',
            submit_text: '显示价格',
            subtitle: '快完成了！我們只需要再一些資料，就可以為您提供報價。',
        },
    },
    wizard: {
        back: '返回',
        reservation: '預訂',
        scheduleMoveIn: '預訂入倉日期',
        copy: '此預訂需要支付費用。請按照步驟完成預訂。在此過程中，我們將為您保留一個迷你倉單位，並通過電子郵件發送詳細信息。',
        selectDate: '選擇您想要入倉日期',
        next: '下一步',
        confirm_booking: '確認預訂',
        payViaFinverse: '通過 Finverse 付款',
        termsAndConditionsAgree: '我同意條款和條件',
        marketingAgree: '允許表收市場推廣訊息',
        dateOfBirth: 'Date of Birth',
        otherError: '發生錯誤，請刷新並重試',
        autobill: '自動於信用卡扣款以避免遲交費用',
        autobillDetails: {
            title: 'Autobill',
            directDebit: 'Direct Debit',
            creditCard: 'Credit Card',
            bsbNumber: 'BSB Number',
            accountNumber: 'Account Number',
        },
        contactDetails: {
            title: '聯繫方式',
            titles: {
                mr: '先生',
                mrs: '太太',
                miss: '小姐',
                ms: '女士',
                dr: '博士',
            },
            commercial: '請輸入您的公司名稱和公司註冊號碼。您必須獲授權代表公司。',
            company: '公司名稱',
            companyNumber: '公司註冊號碼',
        },
        alternateContactDetails: {
            title: '替代聯繫方式',
            subtitle: '如果我們無法聯繫到您，這些信息將使我們能夠聯繫其他人。',
        },
        accountDetails: {
            title: '帳戶詳情',
            copy: '必須為8到20個字符長，包含至少一個大寫和小寫字符以及至少一個數字。此密碼將允許您在入住後登錄並在線支付您的帳戶。',
            password: '線上密碼',
            confirmPassword: '確認線上密碼',
        },
        reservationWithFee: {
            orderNumber: '訂單號碼：: ',
            confirmationText:
                '我們已經通過電子郵件向您發送了訂單的所有詳細信息，請記住您可以使用此應用程序跟蹤您的訂單。',
        },
        insuranceCoverage: {
            title: '保險保障範圍',
            subtitle:
                '保險不包括在我們的租金內。我們強烈建議所有客戶為他們的物品投保以獲得安心。',
            coverage: '保險保障範圍',
            noInsuranceSelected: '未選擇保險',
            manualEntryLabel: '儲存物品的申報價值',
            disclaimer:
                '勾選此框即表示您接受並同意：所選的保險範圍選項將涵蓋您所申報物品的實際更換價值，同意以下條款和條件，並了解保險單的包括/不包括項目。',
            flatRateInsurance: '固定費率保險',
            selfInsurance: '自行購買保險',
            usSupply: '如果您希望我們提供保險，請選擇此選項。',
            subTitle: '如果您將自行提供保險，請選擇此選項',
            proofDisclaimer: '注意：您需要上傳保險證明以完成預訂',
            fileTypePlease: '請上傳jpg、png或pdf文件，使用以下的保險證明部分。',
        },
        addressProof: {
            title: '地址證明',
            subtitle: '上傳文件顯示您提供的地址證明',
            fileUploadHelpText:
                '請上傳一張顯示您當前地址的照片。例子包括銀行對賬單、信用卡對賬單或水電賬單。',
            uploading: '上傳中...',
            success: '文件上傳成功',
            error: '上傳文件時出錯',
        },
        insuranceProof: {
            title: '保險證明',
            subtitle: '上傳文件顯示為您申報的金額購買',
            fileUploadHelpText: '一張護照証件照片（包括顯示頭部和肩部）',
            uploading: '上載中…',
            success: '檔案上傳成功',
            error: '檔案上傳失敗',
        },
        boxShop: {
            title: '搬運與包裝用品供應',
            outOfStock: '沒有庫存',
            pickUpLocation: '取貨地點',
            showAll: '顯示全部',
            showLess: '顯示部份'
        },
        pricingTable: {
            title: 'Booking Summary',
            charge: '費用',
            amount: '數量',
            discount: '折扣',
            initialAmount: '初始金額',
            tax: '稅項',
            total: '總計',
        },
        identityVerification: {
            title: '身份驗證',
            driverLicenseDetails: '車牌資訊',
            uploadDriverLicense: '駕駛執照',
            fileUploadHelpText:
                '請上傳您駕駛執照或護照正面的照片，格式為 JPG、PNG 或 PDF 檔案。',
            idDocumentNumber: '身份証號碼'
        },
        paymentForm: {
            title: 'Payment',
            errors: {
                cardHolderInvalid: 'Card Holder Name is invalid',
                cardNumberInvalid: 'Card Number is invalid',
                cardExpiryInvalid: 'Card Expiry is invalid',
                cardCsvInvalid: 'Card CSV is invalid',
            },
        },
        bookingConfirmation: {
            title: '感謝您的預約',
            subtitle:
                '我們已經向您發送了一封包含更多詳細資訊的電子郵件，請參考該電子郵件以獲取進一步信息。',
            referenceCode: '參考編碼',
            customerSurvey: {
                title: '顧客問卷',
                subtitle:
                    '我們非常重視客戶的反饋，如果您能回答下面的一些簡單問題，我們將非常感謝！',
                submit: '遞交問卷',
            },
            idVerifyButtonText: '验证您的身份',
            idVerifyText: '请使用下面的按钮验证您的 ID。或者，您可以稍后在应用程序中执行此操作',
        },
        marketingSurvey: {
            title: '顧客問卷',
            subtitle:
                '通過回答以下問題來幫助我們改善服務',
            Marketing: '您是從哪裡得知我們的？',
            MktgDistance: '您與我們的距離？',
            MktgWhy: '您為什麼要儲存？',
            MktgType: '哪一項最能描述您？',
            MktgWhat: 'What are you storing?',
            MktgReason: '您為什麼選擇我們品牌儲存？',
            submit: '通過回答以下問題來幫助我們改善服務',
        },
    },
    error: {
        oops: '發生了錯誤',
        subtitle: '抱歉，發生了意外錯誤',
        general_error: '發生了一般錯誤，請再試一次或聯繫支援',
        go_back: '返回',
        not_found:
            '您請求的頁面找不到，請檢查您是否輸入錯誤的資料，或該頁面可能已移動',
    },
};
